import { Col, Row } from "antd";
import React from "react";
const IncomeStaffRemaining = ({ record, max }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  if (record) {
    return (
      <Col span={24}>
        <Row justify="space-between">
          <Col>Remaining value:</Col>
          <Col>${max}</Col>
        </Row>
      </Col>
    );
  }
  return null;
};
export default IncomeStaffRemaining;
